import React from 'react';
import { ShieldCheck } from 'lucide-react';

export function PrivacyNotice() {
  return (
    <div className="flex items-start gap-2.5 p-3 mt-3 bg-emerald-50 dark:bg-emerald-500/10 border border-emerald-100 dark:border-emerald-500/20 rounded-xl">
      <ShieldCheck className="w-4 h-4 text-emerald-600 dark:text-emerald-400 mt-0.5 shrink-0" />
      <div>
        <div className="text-[11px] font-semibold text-emerald-800 dark:text-emerald-300 uppercase tracking-wider mb-0.5">Privacy First</div>
        <p className="text-xs text-emerald-600 dark:text-emerald-400/80 leading-relaxed">
          All of your data is stored locally on your device. During analysis, your information is securely transmitted to be processed by Google's AI, but we never save, log, or retain any of your resume or job details.
        </p>
      </div>
    </div>
  );
}
